import React from "react";
import { clients } from "../data/content";

function LogoStrip() {
  return (
    <section className="logo-strip" aria-label="Clients">
      <div className="container logo-strip-inner">
        <p className="logo-strip-label">Trusted by organizations across industries</p>
        <ul className="logo-strip-list">
          {clients.map((c) => (
            <li key={c.name}>
              <img src={c.logo} alt={c.name} loading="lazy" />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default LogoStrip;
